<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-between tw-px-4 tw-items-center tw-mb-4">
      <span class="tw-text-sm tw-font-semibold tw-text-secondary-500">
        {{ t('users.titles.user_list') }}
      </span>
      <router-link
        :to="{
          name: 'create-user',
        }"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('users.titles.add') }}
      </router-link>
    </div>
    <UsersFancyTable :customerId="selectedCustomerId" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import UsersFancyTable from './Table/UsersFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import { useI18n } from 'vue-i18n';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';
import { useCustomerStore } from '@/stores/customer.store';

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.users',
    },
  ]);
});
</script>
